function getMz() {
  let { _mz, _mze } = global;

  if (_mz === undefined || _mze === undefined) {
    _mz = window._mz
    _mze = window._mze

    return { _mz, _mze }
  }

  return { _mz, _mze }
}

const hasMz = () => {
  const { _mz, _mze } = getMz();
  return _mz && _mze;
};

const mzSupportsFn = (fn) => {
  const { _mz } = getMz();
  return (typeof _mz?.[fn] === 'function');
};

const mzSupportsEvent = (event) => {
  const { _mze } = getMz();

  return _mze?.[event] !== undefined;
};

const emit = (event, options = {}, retries = 5) => {
  console.log("HAS MZ:", hasMz());
  console.log(`MZ SUPPORTS ${event}:`, mzSupportsEvent(event))
  console.log('MZ SUPPORTS EMIT: ', mzSupportsFn('emit'));

  const { _mz, _mze } = getMz();

  if (hasMz() && mzSupportsEvent(event) && mzSupportsFn('emit')) {
    console.log(`EMIT ${event}: SUCCESS`);
    return _mz.emit(_mze[event], options);
  }

  if (retries === 0) {
    console.log(`EMIT ${event}: FAIL`);
    return false;
  }
  
  console.log(`EMIT ${event}: RETRY ${5 - retries + 1} out of 5`);
  return setTimeout(() => emit(event, options, retries - 1), 1500);
};

// options = {documentReferrer: this.props.documentReferrer}; ??!!
// https://github.com/tes/app-resource/blob/25a392e061a3ee7986d719fef9046ccbce808192/src/ui/containers/TrackingApp.js#L161

export const emitView = (options = {}) => emit('PAGE_VIEW', options);

export const emitDisplay = (type) => (name) => emit('DISPLAY', {module: { type, name }});

export const emitClick = (payload) => emit('CLICK', {...payload});

export const emitExitClick = (link) => emit('EXIT_CLICK', {
  action: 'exit-link',
  url: link
});

export const emitError = (id, eventTitle) => emit('ERROR', {id, eventTitle});

export const emitSubmit = (payload) => emit('SUBMIT', {...payload});

export const emitReview = (payload) =>  emit('REVIEW', {
  module: { name: 'review' },
  eventTitle: 'review',
  ...payload,
});

export const emitClickBuy = () => emitClick({ eventTitle: 'Click buy' });

export const emitClickUpgradeSchoolLicence = () => emitClick({ eventTitle: 'Click School Licence Upgrade' });

export const emitClickPay = (payload) => emitSubmit({
  eventTitle: 'Make payment',
  method: 'Credit Card',
  tags: ['funnel'],
  ...payload,
});

export const emitCompletePayment = (resourceIds) =>
  resourceIds.map(resourceId => emitSubmit({ eventTitle: 'Complete payment', resourceId }));

global.window.addEventListener('load', () => {
  const { _mz } = getMz();

  if (hasMz() && mzSupportsFn('registerAutoHandlers')) {
    _mz.registerAutoHandlers(_mz, _mz.environment);
  }
  console.log('DOC LOAD EVENT');
  emitView();
});
